import { Article } from './../article';
export class ModelCurrentTaskPiecesTime {
  constructor(
    public timePerPiece: number,
    public piecesPerHour: number,
    public medianTimePerPiece: number,
    public realTimePerPiece: number,
    public lastTimePerPiece: number,
    public article: Article
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-current-task-pieces-time.ts